define('app/sds/additionaldata/sds-additionaldata',["filter!date", "service!selcomm", "$q", "$timeout"], function (dateFilter, SelcommWS, $q, $timeout) {
	"use strict";
	return {
		controller: {
			bind: {
				"additionalFieldData": "=",

				"_add": "&add",
				"_update": "&update",
				"_delete": "&delete",

				"_canAdd": "&canAdd",
				"_canUpdate": "&canUpdate",
				"_canDelete": "&canDelete"
			},
			prototype: {
				format: "shortDate",
				normalizeType: function (type) {
					type = type || "";
					switch (type.toLowerCase()) {
						case "bool":
						case "boolean":
							return "bool";
						case "list":
						case "stringlist":
						case "select":
							return "select";
						case "int":
						case "integer":
							return "int";
						case "string":
						case "text":
							return "text";
						default:
							return type;
					}
				},
				updateAdditionalFieldData: function (additionalFieldData) {
					if (additionalFieldData.Information) {
						return SelcommWS.put("Contact", "ContactAdditionalFieldDataUpdate", {
							AdditionalFieldData: additionalFieldData
						});
					} else {
						return SelcommWS.put("Contact", "ContactAdditionalFieldDataDelete", {
							AdditionalFieldData: additionalFieldData
						});
					}
					
				},
				trimmedAttribValue: function myTrim(x) {
					return x.replace(/^\s+|\s+$/gm, '');
				}
			},
			properties: {
				normalizedAttributeType: function () {
					if (this.additionalFieldData.AdditionalField.PossibleValues && this.additionalFieldData.AdditionalField.PossibleValues.length >1) {
						return this.normalizeType("select");
					}
					else {
						if (this.additionalFieldData.Information) {
							return this.normalizeType(typeof this.additionalFieldData.Information);
						} else {
							return this.normalizeType("text");
						}
						
					}
				},
				boundAttributeValue: {
					get: function () {
						if (this._fixValue) {
							return undefined;
						}
						if ("_boundAttributeValue" in this) {
							return this._boundAttributeValue;
						}
						else {
							if (this.additionalFieldData) {
								return this.additionalFieldData.Information;
							}
						}
					},
					set: function (newValue) {
						//if (this.attribute && this.attribute.value === newValue) {
						if (this.additionalFieldData && this.additionalFieldData.Information === newValue) {
							delete this._boundAttributeValue;
						}
						else {
							this._boundAttributeValue = newValue;
						}
					}
				},
				//dropdownBoundAttributeValue: {
				//	get: function () {
				//		this.additionalFieldData.Information;
				//	},
				//	set: function (newValue) {
				//		if (typeof value === "string") {
				//			var asNumber = Number(newValue);
				//			if (!isNaN(asNumber)) {
				//				newValue = asNumber;
				//			}
				//		}

				//		this.boundAttributeValue = newValue;
				//	}
				//},
				dateTimeBoundAttributeValue: {
					get: function () {
						return dateFilter(this.additionalFieldData, this.format);
					},
					set: function (newValue) {
						return this.boundAttributeValue = newValue;
					}
				},
				state: {
					get: function () {
						if (this._deleting) {
							return "delete";
						}
						else if ("_boundAttributeValue" in this) {
							return "update";
						}
					},
					set: function (newState) {
						switch (newState) {
							case "delete":
								this._deleting = true;
								break;
							case "update":
								this._deleting = false;
								this._boundAttributeValue = this.additionalFieldData.Information;
								break;
							default:
								this._deleting = false;
								delete this._boundAttributeValue;
								break;
						}
					}
				}

			},
			constructor: ["$attrs", "$transclude", "$self", "$watch", function ($attrs, $transclude, vm, $watch) {
				var vm = this;
				!$attrs.canAdd && (vm._canAdd = function () { return true; });
				!$attrs.canUpdate && (vm._canUpdate = function () { return true; });
				!$attrs.canDelete && (vm._canDelete = function () { return true; });
				var isDefined = {
					add: "add" in $attrs,
					update: "update" in $attrs,
					delete: "delete" in $attrs
				};

				$watch("vm.additionalFieldData.AdditionalField.PossibleValues", function (possibleValues) {
					if (possibleValues && possibleValues.length > 0) {
						vm._fixValue = true;
						$timeout(function () {
							vm._fixValue = false;
						});
					}
				});
				function addAttr() {
					return vm._add({
						$adding: angular.extend({}, vm.additionalFieldData, {
							value: vm.boundAttributeValue
						})
					});
				}
				function updateAttr() {
					vm.additionalFieldData.Information = vm.boundAttributeValue;
					var additionalFieldToUpdate = { KeyValue: vm.additionalFieldData.KeyValue, Information: vm.additionalFieldData.Information, AdditionalField: { InfoType: vm.additionalFieldData.AdditionalField.InfoType } }
					return $q(function ($return, $throw) {
						if (vm.form.$valid) {
							return vm.updateAdditionalFieldData(additionalFieldToUpdate)
							.then(function (result) {
								$updating: angular.extend({}, vm.additionalFieldData, {
									Information: vm.boundAttributeValue
								});
								$return();
							})
							.catch(function (result) {
								$throw();
							});
						}
					});
				}
				function deleteAttr() {
					return vm._delete({
						$deleting: vm.additionalFieldData
					})
				}

				Object.defineProperties(vm, {
					add: { get: function () { return isDefined.add ? addAttr : null; } },
					update: { get: function () { return isDefined.update ? updateAttr : null; } },
					delete: { get: function () { return isDefined.delete ? deleteAttr : null; } },
					canAdd: { get: function ($adding) { return this.add && this._canAdd.call(vm, { $adding: $adding }); } },
					canUpdate: { get: function ($updating) { return this.update && this._canUpdate.call(vm, { $updating: $updating }); } },
					canDelete: { get: function ($deleting) { return this.delete && this._canDelete.call(vm, { $deleting: $deleting }); } },
				});
			}]
		}
	};
});
